import React from 'react'

import {
  Box,
  Button,
  FormControlLabel,
  Grid,
  Switch,
  Typography,
} from '@material-ui/core'
import { Controller, useFormContext } from 'react-hook-form'
import { Download } from 'react-feather'
import { KeyboardDatePicker } from '@material-ui/pickers'

import { FileUploadInput } from 'components'

import { getBaseURL } from 'service/env'

const PartnerInfoForm = () => {
  const { control, errors, watch } = useFormContext()

  const downloadModelSuppliers = () => {
    const link = 'modelo_importacao_de_fornecedores.xlsx'

    window.open(`${getBaseURL('dponet')}/${link}/`, '_blank')
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Box display="flex" flexDirection="column">
          <FormControlLabel
            control={
              <Controller
                as={<Switch color="primary" />}
                name="simplifiedRegister"
                control={control}
              />
            }
            label="Cadastro Simplificado"
            labelPlacement="end"
          />
          <FormControlLabel
            control={
              <Controller
                as={<Switch color="primary" />}
                name="international"
                control={control}
              />
            }
            label="Fornecedor Internacional"
            labelPlacement="end"
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1">
          Para importar fornecedores, é necessário seguir o modelo de planilha
          que disponibilizamos. Caso não seja seguido, podem ocorrer falhas na
          importação dos dados.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Button
          color="primary"
          variant="contained"
          size="large"
          endIcon={<Download size={20} />}
          onClick={downloadModelSuppliers}
        >
          Baixar Modelo
        </Button>
      </Grid>
      <Grid item xs={12}>
        <FileUploadInput accept=".xlsx" controlName="document" />
      </Grid>

      <Grid item xs={12}>
        <Controller
          as={
            <KeyboardDatePicker
              disablePast
              fullWidth
              format="DD/MM/yyyy"
              label="Data para o disparo do e-mail"
              helperText={errors?.date?.message}
              error={!!errors?.date}
              invalidDateMessage="Data inválida"
            />
          }
          defaultValue={watch('date') || null}
          control={control}
          name="date"
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          as={
            <KeyboardDatePicker
              disablePast
              fullWidth
              format="DD/MM/yyyy"
              label="Estipule um prazo para que eles respondam aos questionários"
              helperText={errors?.endDate?.message}
              error={!!errors?.endDate}
              invalidDateMessage="Data inválida"
            />
          }
          defaultValue={watch('endDate') || null}
          control={control}
          name="endDate"
        />
      </Grid>
    </Grid>
  )
}

export default PartnerInfoForm
